import React, { useEffect, useRef } from 'react';
import { useUserAuth } from '../../context/userAuthContext';

// Translations for the StrategicPartners component
const translations = {
    en: {
        heading: 'STRATEGIC PARTNERS',
        title: 'Trusted by Industry Leaders'
    },
    es: {
        heading: 'PARTNERS ESTRATÉGICOS',
        title: 'Respaldados por Líderes de la Industria'
    }
};

// Partner logos data
const partners = [
    {
        name: "Amazon Web Services",
        logo: "https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg"
    },
    {
        name: "Microsoft",
        logo: "https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg"
    },
    {
        name: "Google",
        logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Google_2015_logo.svg/640px-Google_2015_logo.svg.png"
    },
    {
        name: "Firebase",
        logo: "https://upload.wikimedia.org/wikipedia/commons/3/37/Firebase_Logo.svg"
    },
    {
        name: "NPM",
        logo: "https://upload.wikimedia.org/wikipedia/commons/d/db/Npm-logo.svg"
    },
    {
        name: "IBM",
        logo: "https://upload.wikimedia.org/wikipedia/commons/5/51/IBM_logo.svg"
    },
    {
        name: "Namecheap",
        logo: "https://1000logos.net/wp-content/uploads/2022/08/NameCheap-Logo.png"
    }
];

// Duplicate the partners array for seamless infinite loop
const allPartners = [...partners, ...partners];

const StrategicPartners = () => {
    const { currentLanguage } = useUserAuth();
    const t = translations[currentLanguage];
    const sliderRef = useRef(null);

    // Animation for infinite slider
    useEffect(() => {
        const slider = sliderRef.current;
        if (!slider) return;

        // Create animation
        const animation = slider.animate(
            [
                { transform: 'translateX(0)' },
                { transform: `translateX(-${partners.length * 100 / allPartners.length}%)` }
            ],
            {
                duration: 35000, // 35 seconds per complete loop (slower)
                iterations: Infinity,
                easing: 'linear'
            }
        );

        // Pause animation when not visible
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    animation.play();
                } else {
                    animation.pause();
                }
            },
            { threshold: 0.1 }
        );

        observer.observe(slider);

        // Cleanup
        return () => {
            animation.cancel();
            observer.disconnect();
        };
    }, []);

    return (
        <div className="bg-gray-50 py-8 md:py-12 w-full overflow-hidden">
            <div className="w-full">
                <div className="text-center mb-6 md:mb-8">
                    <h3 className="text-sm md:text-base font-medium text-blue-500 mb-1 md:mb-2">{t.heading}</h3>
                    <h2 className="text-xl md:text-3xl font-bold text-gray-800">
                        {t.title}
                    </h2>
                </div>

                {/* Infinite slider container - Full width */}
                <div className="relative w-full overflow-hidden">
                    <div
                        ref={sliderRef}
                        className="flex items-center whitespace-nowrap"
                        style={{ width: `${allPartners.length * 14.28}%` }} // Wide enough to fit all logos
                    >
                        {allPartners.map((partner, index) => (
                            <div
                                key={index}
                                className="flex-shrink-0 px-5 sm:px-10 md:px-20 lg:px-28 w-1/7 flex items-center justify-center"
                            >
                                <img
                                    src={partner.logo}
                                    alt={`${partner.name} logo`}
                                    className="h-10 sm:h-12 md:h-16 w-auto object-contain"
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StrategicPartners;